import { render } from "./row.vue?vue&type=template&id=12af85d4"
import script from "./row.vue?vue&type=script&lang=js"
export * from "./row.vue?vue&type=script&lang=js"

import "./row.vue?vue&type=style&index=0&id=12af85d4&lang=scss"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__